<template>
  <bootstrap id="past-purchases__top">
    <error-container v-bind:type="'pastPurchases'"></error-container>
    <div
      v-if="products.length === 0"
      v-html="noPastPurchasesMessage"
      class="d-flex justify-content-center past-purchases__message-no-past-purchases"
    >
      <!-- Message from BCC: Key: noPastPurchases -->
    </div>

    <div v-if="products.length" class="past-purchases__sort-bar">
      <label class="past-purchases__text" for="past-purchases-sort-by">Sort by</label>
      <select @change="changeSort" id="past-purchases-sort-by" v-model="sort">
        <option value="frequent">Most Frequent</option>
        <option value="alpha">Product A-Z</option>
        <option value="recent">Most Recent</option>
      </select>
    </div>
    <div class="past-purchases__grid">
      <product-card
        :product="product"
        v-for="(product,index) in products"
        :key="index"
        listname="Past Purchases"
        :position="index+1"
        product-class-name="past-purchases__grid-item product-card"
      />
    </div>

    <b-pagination
      @change="scrollToTop"
      v-model="currentPage"
      v-show="products.length"
      :total-rows="totalCount"
      role="navigation"
      :per-page="PER_PAGE"
      aria-controls="change-stores-list"
      hide-goto-end-buttons
      align="right"
      style="margin-bottom: 1rem;"
    >
      <span aria-hidden="true" slot="next-text">▶</span>
      <span aria-hidden="true" slot="prev-text">◀</span>
    </b-pagination>
  </bootstrap>
</template>
<script>
import ProductCard from "./product/ProductCard";
import Errors from "./Errors";

export default {
  name: "PastPurchases",
  components: {
    "product-card": ProductCard,
    "error-container": Errors
  },
  data() {
    const urlParams = new URLSearchParams(window.location.search);

    return {
      /** @type {number} pagination: current page */
      currentPage: parseInt(urlParams.get("page")) || 1,

      /** @type {boolean} flag for whether or not current user is a guest */
      isUserGuest: window.heb.data.user.isGuest,

      /** @type {number} pagination: stores per page */
      PER_PAGE: 40,

      /** @type {string} sorting option: frequent | alpha | recent; default: frequent */
      sort: urlParams.get("sort") || "frequent"
    };
  },
  computed: {
    products() {
      return this.$store.state.orderHistory.pastPurchases.productItems || "";
    },
    totalCount() {
      // When the user navigates back from a product PDP, we should return
      // the user to the same pagination page the user left from. We need a
      // high enough "totalCount" to not confuse the v-pagination model by default.
      const defaultCount = this.currentPage * this.PER_PAGE;
      const historyCount = this.$store.state.orderHistory.pastPurchases.totalCount;
      return historyCount || defaultCount;
    },
    numberOfPages() {
      return Math.ceil(this.totalCount / this.PER_PAGE);
    },
    noPastPurchasesMessage() {
      const objectPath = "data.message.noPastPurchases";
      const emptyMsg =
        "Once you make an online order, you’ll be able to shop your past purchases here.";
      return _.get(heb, objectPath, emptyMsg);
    }
  },
  mounted: function() {
    if (!this.isUserGuest) {
      this.getPastPurchases();
    }
  },
  methods: {
    changeSort(e) {
      this.currentPage = 1;
      this.getPastPurchases();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    getPastPurchases() {
      history.pushState("", "", `?page=${this.currentPage}&sort=${this.sort}`);
      this.$store.dispatch("orderHistory/GET_PAST_PURCHASES", {
        count: this.PER_PAGE,
        sort: this.sort,
        start: this.currentPage * this.PER_PAGE - this.PER_PAGE
      });
    }
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.currentPage = newValue;
      this.getPastPurchases();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/lib";

.past-purchases__sort-bar {
  text-align: right;
  box-sizing: border-box;
}

.past-purchases__text {
  font-weight: 700;
  font-style: normal;
  padding-right: 0.5rem;
}

.past-purchases__message-no-past-purchases {
  font-weight: 700;
}

.past-purchases__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, max-content)); //desktop 4 per row
  grid-gap: .25rem;
}

@media only screen and (max-width: 640px) {
  .past-purchases__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.past-purchases__grid-item {
  flex-direction: column;
  max-width: 100%;
}
</style>
